import { Skeleton } from '@mui/material'
import React from 'react'
import StoreCardSkeleton from '../../../../../components/card/Store/StoreCardSkeleton'

const LoanTemplateDetailSkeleton = () => {
    return (
        <div style={{ height: "100svh", paddingInline: "20px", overflowY: "auto", paddingTop: "15px", paddingBottom: "60px" }}>
            <Skeleton variant='rectangular' width={"100%"} height={40} sx={{ backgroundColor: "lightgray" }} />
            <div className='py-5 w-full' style={{ paddingTop: "20px" }}>
                <Skeleton variant='rectangular' width={"100%"} height={40} sx={{ backgroundColor: "lightgray" }} />
            </div>
            <Skeleton variant='rectangular' width={"100%"} height={40} sx={{ backgroundColor: "lightgray" }} />
            <div className='py-5 w-full flex gap-2 overflow-x-auto' style={{ paddingTop: "20px" }}>
                {[...Array(5)]?.map((_, index) => (
                    <Skeleton key={index} variant='rectangular' sx={{ borderRadius: "20px", backgroundColor: "lightgray" }} width={"100%"} height={40} />
                ))}
            </div>
            <div className='flex flex-col gap-4 pb-10'>
                <StoreCardSkeleton />
            </div>
        </div>
    )
}

export default LoanTemplateDetailSkeleton